import { Component, Input, OnInit } from "@angular/core";
import * as moment from "moment";

@Component({
  selector: "app-card-medicamentos-component",
  templateUrl: "./card-medicamentos-component.component.html",
  styleUrls: ["./card-medicamentos-component.component.scss"],
})
export class CardMedicamentosComponentComponent implements OnInit {
  @Input("data") medicamento;
  @Input("ultimo") ultimo;
  constructor() { }

  ngOnInit() { }

  abrirItem() {
    this.medicamento.selecionado = !this.medicamento.selecionado;
  }
  dateLabel(date: string) {
    return `${moment(date, "DD/MM/YYYY hh:mm:ss").format("L")}`;
  }
}
